// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/map-reading-technique.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/map-reading-technique/map-reading-technique.js';

mount([g0]);
